var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQr3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h200v200H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "translate(-.138 -.138) scale(.00862)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "b",
    width: 148,
    height: 148,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJQAAACUCAIAAAD6XpeDAAAAA3NCSVQICAjb4U/gAAADSklEQVR4nO2dzWrEMAwGm9L3f+XtNT0YrOpT1sPOHIs3CR2EkOWf6/V6fQmT73d/gPwf5YFRHhjlgVEeGOWBUR4Y5YFRHhjlgVEeGOWBUR4Y5YFRHpif6g+u64p/xL2neH/+qte4M2Y1fvXe6vjp/8MORh4Y5YFRHphyzrvTWf9SzRmp8Tv5tZrbnvw/3DHywCgPjPLAtHLenVRu2Mk31fqs+j3VOrL6Dam1skYeGOWBUR6YWM5LUc1z1TGdPHravg4jD4zywCgPzHE5b1XnpWq4J+ctpzHywCgPjPLAxHLeRG5IzXN28l+1znsyRxp5YJQHRnlgWjlvYu1iJ1dV5zZTteDE/2EHIw+M8sAoD8x12tzdk3sAOr3DEzDywCgPjPLAtPbnVeceU/2z6jesflt9fmpMKtcaeWCUB0Z5YEb6eRO5bee3E/VcZ19gau50hZEHRnlglAemNbc5fR5K57epWupd+XsHIw+M8sAoD0ysn5ea66v+vUpq7rSzjmbnXTsYeWCUB0Z5YGLnbU709qrvnX7OxJyqdd6HojwwygNTrvOmz4B+Moc9uSd94l1GHhjlgVEemHKdVz2jecVE7qzON06s+XRPumyhPDDKAxOb2+zcY7DznNWY6X5bionvMfLAKA+M8sC06rw7qTX9nZ5ftd+2GlOt53bOBZ3ItUYeGOWBUR6YkX5edXynRkz1857ce179zhVGHhjlgVEemJF+3kQOOOF8584e+Yn5VSMPjPLAKA9MrJ+3M35i/3tqfeZEP3I6Bxt5YJQHRnlgWmePdWq7iX3cnWdW511PuG/ByAOjPDDKA3P0vQqp9TJ3nuxfVnF/3gehPDDKAzM+t7nDRC5JzaPujJnYO7iDkQdGeWCUByY2t1klVQ9N9wtPvmPPyAOjPDDKAxO7Syi1Ln/i7OYUnVpzogdp5IFRHhjlgYnlvBSd3NDZS14d31mn49ymKI+M8sAcl/PuTK8HSd29N3E/0Q5GHhjlgVEemJF70lPP6dRPq/HVd6XOXrHOkz8oD4zywLRy3nTPLHVPQicnpdZnTmDkgVEeGOWBOW5/nuxj5IFRHhjlgVEeGOWBUR4Y5YFRHhjlgVEeGOWBUR4Y5YFRHhjlgfkF+bhENOhEcBkAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr3);
export default __webpack_public_path__ + "static/media/qr-3.bb27162217f920434021ec9f4de909db.svg";
export { ForwardRef as ReactComponent };